import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Email-first checkout gate status banner, rendered above the new-payment-method creation area (saved methods
 * sit above it, outside the gate). When visible it shows either the locked prompt ("enter a valid email") or
 * the verified confirmation. It hides itself entirely when not `active`, or when `prepopulated` (the payer's
 * email was already provided, so neither status is relevant). The per-option locking (greying, lock icon,
 * shake, click interception) lives on the new-payment-method-type options themselves.
 */
@Component({
  selector: 'app-payment-method-gate',
  templateUrl: './payment-method-gate.component.html',
  styleUrls: ['./payment-method-gate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    class: 'small-300',
    '[class.payment-method-gate--hidden]': '!visible()',
    '[class.payment-method-gate--locked]': 'visible() && locked()',
    '[class.payment-method-gate--verified]': 'visible() && !locked()',
  },
})
export class PaymentMethodGateComponent {
  /** Whether the email gate applies at all. When false the component hides itself. */
  active = input(false);
  /** Whether the methods are currently locked (no valid email yet). */
  locked = input(false);
  /** Whether the email was prepopulated and untouched — when true the component hides itself. */
  prepopulated = input(false);

  visible = computed(() => this.active() && !this.prepopulated());
}
